<script lang="ts" setup>
import { defineAsyncComponent } from 'vue'
const MainMenuTab = defineAsyncComponent(async () => await import('./../home/main-menu-tab.vue'))

</script>
<template>
  <div class="sport-schedules">
    <MainMenuTab />
    <div class="container position-relative">
      <div class="sport-schedules__content">
        <div class="wrapper-schedules">
          <div class="wrapper-schedules__content">
            <slot />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped lang="scss">
@import '~scssAsset/desktop/pages/sports/wrapper.scss';
</style>
